import { Component, OnInit } from "@angular/core";
import { Event, Router, NavigationStart, NavigationEnd } from "@angular/router";
import { PlatformLocation } from "@angular/common";
import { NgxSpinnerService } from "ngx-spinner";
import { ProgressBarService } from "./services/shared-service/progress-bar/progress-bar.service";
@Component({
	selector: "app-root",
	templateUrl: "./app.component.html",
	styleUrls: ["./app.component.scss"],
})
export class AppComponent implements OnInit {
	currentUrl: string;
	progressColor = "red";
	constructor(
		public _router: Router,
		location: PlatformLocation,
		private spinner: NgxSpinnerService,
		public progressBarService: ProgressBarService
	) {
		this._router.events.subscribe((routerEvent: Event) => {
			if (routerEvent instanceof NavigationStart) {
				this.spinner.show();
				location.onPopState(() => {
					window.location.reload();
				});
				this.currentUrl = routerEvent.url.substring(
					routerEvent.url.lastIndexOf("/") + 1
				);
			}
			if (routerEvent instanceof NavigationEnd) {
				this.spinner.hide();
			}
			window.scrollTo(0, 0);
		});
	}
	ngOnInit() {}
}
